import { NgModule } from '@angular/core';

import { ApiResultsMergePipe } from './api-results-merge';

@NgModule({
  declarations: [ApiResultsMergePipe],
  exports: [ApiResultsMergePipe]
})
export class ApiResultsMergePipeModule { }
